/* Arteriel consent banner — Plan 8 Task 6.
 *
 * Shows the banner on first visit, persists the shopper's choice in
 * localStorage under "arteriel-consent", and fires a DOM CustomEvent so
 * the recommendations IIFE in arteriel-ai.js can react if the choice
 * changes within a single page view.
 *
 * No innerHTML — this script only toggles the `hidden` attribute.
 */
(function () {
  "use strict";
  var KEY = "arteriel-consent";
  var banner = document.getElementById("arteriel-consent");
  if (!banner) return;

  // The banner is position:fixed at z-index 9999, so it sits above every
  // bottom-anchored surface on the page — it covered the concierge composer
  // and its Ask button on every page until answered (UI review 2026-09-11).
  // Lowering it under the concierge is the wrong fix: a consent dialog that
  // can be buried is worse than one that overlaps. So publish the space it
  // occupies instead, and let bottom-anchored UI inset by it.
  //
  // Measured rather than hardcoded because the bar reflows to a column on
  // narrow viewports (responsive.css) and its height is not knowable from CSS.
  function reflect(open) {
    var docEl = document.documentElement;
    docEl.classList.toggle("arteriel-consent-open", open);
    if (!open) { docEl.style.removeProperty("--arteriel-consent-inset"); return; }
    var rect = banner.getBoundingClientRect();
    // The bar floats ABOVE the viewport bottom, so the space it denies is its
    // own height plus that gap — not the height alone.
    var gap = Math.max(0, (window.innerHeight || 0) - rect.bottom);
    docEl.style.setProperty("--arteriel-consent-inset", Math.ceil(rect.height + gap) + "px");
  }

  var current = null;
  try { current = localStorage.getItem(KEY); } catch (e) { /* ignore */ }
  if (current === null) {
    banner.hidden = false;
    reflect(true);
    // Re-measure on reflow: the bar stacks to a column on narrow viewports, so
    // a rotate or resize while it is still unanswered changes its height.
    window.addEventListener("resize", function () {
      if (!banner.hidden) reflect(true);
    });
  }

  banner.addEventListener("click", function (e) {
    var value = e.target && e.target.dataset && e.target.dataset.consent;
    if (!value) return;
    try { localStorage.setItem(KEY, value); } catch (er) { /* ignore */ }
    banner.hidden = true;
    // Release the reserved strip in the same breath the bar goes away — a
    // stale inset leaves a permanent dead band at the bottom of every page.
    reflect(false);
    document.dispatchEvent(new CustomEvent("arteriel-consent", { detail: value }));
    // Signed in: record the choice on the customer too. event_ingest gates a
    // signed-in shopper's events on the arteriel.personalization_consent
    // metafield, and until 2026-09-06 nothing on the storefront wrote it.
    // Best effort; keepalive so a click-then-navigate still delivers.
    var customerId = banner.dataset.customerId;
    if (customerId && typeof fetch === "function") {
      fetch("/apps/arteriel-ai/consent", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ granted: value === "granted" }),
        keepalive: true,
        credentials: "same-origin",
      }).catch(function () { /* localStorage already holds the choice */ });
    }
  });

  window.arterielConsent = function () {
    try { return localStorage.getItem(KEY); } catch (e) { return null; }
  };
})();
